import React, { Component } from 'react'
import {
  Button, Container, Divider, Grid, Card,
  Header, Menu, Segment, Icon, Image, Item,
  Form, Feed, Dropdown, Input, Label, List
} from 'semantic-ui-react'
import EntryItem from 'components/EntryItem/index';
import UpdatableEntryItem from 'containers/UpdatableEntryItem';
import IconButton from 'components/IconButtons/index';
import EntryGroup from 'components/EntryGroup/index';
import EditPanel from 'components/EditPanel/index';
import TagDropdown from 'components/TagDropdown/index';

import img1 from 'assets-theming/images/avatar/small/veronika.jpg'
import img2 from 'assets-theming/images/avatar/small/jenny.jpg'
import img3 from 'assets-theming/images/avatar/small/christian.jpg'


class ThemingLayout extends Component {
  state = {}
  handleChange = (e, { value }) => this.setState({ value })

  render() {
    return (
      <Container style={{ marginTop: '3em' }}>
        <Header as='h1'>Theming Examples</Header>

          <Header as='h2' dividing>Icon Buttons</Header>

          <Grid>
            <Grid.Column>
              <IconButton name={'select'} />
            </Grid.Column>
            <Grid.Column>
              <IconButton name={'select'} active={true} />
            </Grid.Column>
            <Grid.Column>
              <IconButton name="close" />
            </Grid.Column>
            <Grid.Column>
              <IconButton name="check" />
            </Grid.Column>
            <Grid.Column>
              <IconButton name="trash" />
            </Grid.Column>
          </Grid>

          <Header as='h2' dividing>Edit Panel</Header>
          <EditPanel />

          <Grid columns='equal' stackable>
            <Grid.Column>
              <Header as='h5' >In Form</Header>
              <Form>
                <TagDropdown options={[
                  {value: "hello", text: "hello", key: "hello"},
                  {value: "open source", text: "open source", key: "open source"},
                  {value: "javascript", text: "javascript", key: "javascript"},
                  {value: "tags tags tags", text: "tags tags tags", key: "tags tags tags"}
                ]}/>
              </Form>
            </Grid.Column>
            <Grid.Column>
              <Header as='h5' >NOT In Form</Header>
              <TagDropdown options={[
                {value: "hello", text: "hello", key: "hello"},
                {value: "open source", text: "open source", key: "open source"},
                {value: "javascript", text: "javascript", key: "javascript"},
                {value: "tags tags tags", text: "tags tags tags", key: "tags tags tags"}
              ]}/>
            </Grid.Column>
          </Grid>


{/* FORMS */}

          <Header as='h2' dividing>Form</Header>
          <Grid columns='equal' stackable>
            <Grid.Column>
              <Form>
                <Dropdown
                  labeled
                  placeholder={"Add New Tags"}
                  fluid
                  selection
                  options={[{text: "hello", key: "hello", value: "hello"}]}
                  search
                  multiple
                />
              </Form>

              <Divider />

              <Header as="h4">inside a menu</Header>
              <Menu secondary>
                <Input placeholder='Search...' />
                <Button>Search</Button>
                <Dropdown
                  labeled
                  placeholder={"Add New Tags"}
                  selection
                  options={[{text: "hello", key: "hello"}]}
                  search
                />
              </Menu>

              <Divider />

              <Form>
                <Header as="h4">inside a form</Header>
                <Form.Group>
                  <Input placeholder='Search...' />
                  <Dropdown
                    labeled
                    placeholder={"Add New Tags"}
                    selection
                    options={[
                      {text: "hello", key: "hello"},
                      {text: "open source", key: "open source"},
                      {text: "javascript", key: "javascript"},
                      {text: "tags tags tags", key: "tags tags tags"}
                    ]}
                    search
                  />
                  <Button>Search</Button>
                </Form.Group>
              </Form>

              <Divider />

              <Item.Group unstackable>
                <UpdatableEntryItem
                  entry={{
                    id: 'abc',
                    title: 'Data Warehouse: Wikipedia',
                    url: 'https://www.google.com',
                    isRead: false,
                    faviconUrl: "https://en.wikipedia.org/static/favicon/wikipedia.ico",
                    dateAdded: new Date(),
                    tags: ['open source', 'javascript']
                  }}
                  >
                </UpdatableEntryItem>
                <UpdatableEntryItem
                  entry={{
                    id: 'abc',
                    title: 'Data Warehouse: Wikipedia',
                    url: 'https://www.google.com',
                    isRead: false,
                    faviconUrl: "https://en.wikipedia.org/static/favicon/wikipedia.ico",
                    dateAdded: new Date(),
                    tags: ['open source', 'javascript']
                  }}
                  isMobile={true}
                  >
                </UpdatableEntryItem>
                <UpdatableEntryItem
                  entry={{
                    id: 'abc',
                    title: 'Data Warehouse: Wikipedia',
                    url: 'https://www.google.com',
                    isRead: false,
                    faviconUrl: "https://en.wikipedia.org/static/favicon/wikipedia.ico",
                    dateAdded: new Date(),
                    tags: []
                  }}
                  isMobile={true}
                  >
                </UpdatableEntryItem>
              </Item.Group>

              <Card
                href='#card-example-link-card'
                header='Elliot Baker'
                meta='Friend'
                description='Elliot is a sound engineer living in Nashville who enjoys playing guitar and hanging with his cat.'
              />

            </Grid.Column>
          </Grid>

{/* FEEDS */}
          <Header as='h2' dividing>Feed</Header>

          <Grid>
            <Grid.Column>
              <div>
                <Label>
                  open source
                  <Icon name='delete' />
                </Label>
                <Label>
                  coding
                  <Icon name='delete' />
                </Label>
                <Label>
                  javascript
                  <Icon name='delete' />
                </Label>
              </div>

              <Divider />

              <div>
                <Feed>
                  <Feed.Event>
                    <Feed.Label>
                      <div>Today</div>
                    </Feed.Label>
                    <Feed.Content>
                      <Item.Group unstackable>
                        <EntryItem
                          entry={{
                            id: 'abc',
                            title: 'Data Warehouse: Wikipedia',
                            url: 'https://www.google.com',
                            isRead: false,
                            faviconUrl: "https://en.wikipedia.org/static/favicon/wikipedia.ico",
                            dateAdded: new Date(),
                            tags: ['open source', 'javascript']
                          }}
                          >
                        </EntryItem>
                        <EntryItem
                          entry={{
                            id: 'abc',
                            title: 'Data Warehouse: Wikipedia',
                            url: 'https://www.google.com',
                            isRead: false,
                            faviconUrl: "https://en.wikipedia.org/static/favicon/wikipedia.ico",
                            dateAdded: new Date(),
                            tags: ['open source', 'javascript']
                          }}
                          >
                        </EntryItem>
                        <EntryItem
                          entry={{
                            id: 'abc',
                            title: 'Data Warehouse: Wikipedia',
                            url: 'https://www.google.com',
                            isRead: false,
                            faviconUrl: "https://en.wikipedia.org/static/favicon/wikipedia.ico",
                            dateAdded: new Date(),
                            tags: ['open source', 'javascript']
                          }}
                          >
                        </EntryItem>
                      </Item.Group>
                    </Feed.Content>
                  </Feed.Event>
                  <EntryGroup header="Yesterday">
                    <EntryItem
                      entry={{
                        id: 'abc',
                        title: 'Data Warehouse: Wikipedia',
                        url: 'https://www.google.com',
                        isRead: false,
                        faviconUrl: "https://en.wikipedia.org/static/favicon/wikipedia.ico",
                        dateAdded: new Date(),
                        tags: ['open source', 'javascript']
                      }}>
                    </EntryItem>
                    <EntryItem
                      entry={{
                        id: 'abc',
                        title: 'Data Warehouse: Wikipedia',
                        url: 'https://www.google.com',
                        isRead: false,
                        faviconUrl: "https://en.wikipedia.org/static/favicon/wikipedia.ico",
                        dateAdded: new Date(),
                        tags: ['open source', 'javascript']
                      }}>
                      </EntryItem>
                      <EntryItem
                        entry={{
                          id: 'abc',
                          title: 'Data Warehouse: Wikipedia',
                          url: 'https://www.google.com',
                          isRead: false,
                          faviconUrl: "https://en.wikipedia.org/static/favicon/wikipedia.ico",
                          dateAdded: new Date(),
                          tags: ['open source', 'javascript']
                        }} >
                      </EntryItem>
                  </EntryGroup>
                  <Feed.Event>
                    <Feed.Label>
                      <div className="dot"></div>
                    </Feed.Label>
                    <Feed.Content>
                      <List>
                        <List.Item>
                          <Image avatar src={img1} />
                          <List.Content>
                            <List.Description>Data Wharehouse - Wikipedia aakdfha</List.Description>
                            Top Contributor
                          </List.Content>
                        </List.Item>
                      </List>
                    </Feed.Content>
                  </Feed.Event>
                  <EntryGroup header="Yesterday">
                    <EntryItem
                      entry={{
                        id: 'abc',
                        title: 'Data Warehouse: Wikipedia',
                        url: 'https://www.google.com',
                        isRead: false,
                        faviconUrl: "https://en.wikipedia.org/static/favicon/wikipedia.ico",
                        dateAdded: new Date(),
                        tags: ['open source', 'javascript']
                      }}>
                    </EntryItem>
                    <EntryItem
                      entry={{
                        id: 'abc',
                        title: 'Data Warehouse: Wikipedia - Example text to take up space',
                        url: 'https://www.google.com',
                        isRead: false,
                        faviconUrl: "https://en.wikipedia.org/static/favicon/wikipedia.ico",
                        dateAdded: new Date(),
                        tags: ['open source', 'javascript']
                      }}>
                      </EntryItem>
                      <EntryItem
                        entry={{
                          id: 'abc',
                          title: 'Running the Cloud Datastore Emulator  |  Cloud Datastore Documentation  |  Google Cloud Platform',
                          url: 'https://www.google.com',
                          isRead: false,
                          faviconUrl: "https://en.wikipedia.org/static/favicon/wikipedia.ico",
                          dateAdded: new Date(),
                          tags: ['open source', 'javascript', 'data', 'coding', 'learn']
                        }} >
                      </EntryItem>
                  </EntryGroup>
                </Feed>
              </div>

              <Divider />

              <div>
              <Label as='a' color='blue' image>
                <img src={img1} />
                Veronika
                <Label.Detail>Friend</Label.Detail>
              </Label>
              <Label as='a' color='teal' image>
                <img src={img2} />
                Veronika
                <Label.Detail>Friend</Label.Detail>
              </Label>
              <Label as='a' color='yellow' image>
                <img src={img3} />
                Helen
                <Label.Detail>Co-worker</Label.Detail>
              </Label>
            </div>

            </Grid.Column>
          </Grid>


          <Header as='h2' dividing>Buttons</Header>

          <Grid columns='equal' stackable>
            <Grid.Column>
              <Button>Default</Button>
              <Button primary>Primary</Button>
              <Button secondary>Secondary</Button>
              <Button basic>Basic</Button>
              <Button compact>Compact</Button>
              <Button primary circular icon="add" size="big"></Button>

              <Divider />

              <Button icon='heart' />
              <Button content='Labeled' icon='heart' labelPosition='left' />
              <Button content='Labeled' icon='heart' labelPosition='right' />

              <Divider />

              <Button.Group>
                <Button>Combo</Button>
              </Button.Group>

              <Divider />

              <Button animated>
                <Button.Content visible>Horizontal</Button.Content>
                <Button.Content hidden>Hidden</Button.Content>
              </Button>
              <Button animated='vertical'>
                <Button.Content visible>Vertical</Button.Content>
                <Button.Content hidden>Hidden</Button.Content>
              </Button>
              <Button animated='fade'>
                <Button.Content visible>Fade In</Button.Content>
                <Button.Content hidden>Hidden</Button.Content>
              </Button>

              <Divider />

              <Button disabled>Disabled</Button>
              <Button loading>Loading</Button>

              <Divider />

              <Button.Group>
                <Button>1</Button>
                <Button>2</Button>
                <Button>3</Button>
              </Button.Group>

              <Button.Group>
                <Button icon='align left' />
                <Button icon='align center' />
                <Button icon='align right' />
                <Button icon='align justify' />
              </Button.Group>

              <Button.Group>
                <Button>1</Button>
                <Button.Or />
                <Button>2</Button>
              </Button.Group>
            </Grid.Column>


            <Grid.Column>
              <Button size='mini'>Mini</Button>
              <Button size='tiny'>Tiny</Button>
              <Button size='small'>Small</Button>
              <Button size='large'>Large</Button>
              <Button size='big'>Big</Button>
              <Button size='huge'>Huge</Button>
              <Button size='massive'>Massive</Button>

              <Divider />

              <Button color='yellow' style={{ marginBottom: '1em' }}>Yellow</Button>
              <Button color='orange' style={{ marginBottom: '1em' }}>Orange</Button>
              <Button color='green' style={{ marginBottom: '1em' }}>Green</Button>
              <Button color='teal' style={{ marginBottom: '1em' }}>Teal</Button>
              <Button color='blue' style={{ marginBottom: '1em' }}>Blue</Button>
              <Button color='purple' style={{ marginBottom: '1em' }}>Purple</Button>
              <Button color='pink' style={{ marginBottom: '1em' }}>Pink</Button>
              <Button color='red' style={{ marginBottom: '1em' }}>Red</Button>
              <Button color='black' style={{ marginBottom: '1em' }}>Black</Button>

              <Divider />

              <Segment inverted>
                <Button inverted>Inverted</Button>
                <Button basic inverted>Basic</Button>
                <Button color='blue' inverted>Colored</Button>
                <Button basic color='blue' inverted>Basic Colored</Button>
              </Segment>
            </Grid.Column>
          </Grid>


          <Header as='h2' dividing>Site</Header>

          <Grid columns={3} stackable>
            <Grid.Column>
              <Header as='h1'>Heading 1</Header>
              <Header as='h2'>Heading 2</Header>
              <Header as='h3'>Heading 3</Header>
              <Header as='h4'>Heading 4</Header>
              <Header as='h5'>Heading 5</Header>

              <p>
                Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient
                montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula.
              </p>
            </Grid.Column>

            <Grid.Column>
              <Header as='h2'>Example body text</Header>
              <p>
                Nullam quis risus eget <a href='#'>urna mollis ornare</a> vel eu leo. Cum sociis natoque penatibus et magnis
                dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula.
              </p>
              <p>
                <small>This line of text is meant to be treated as fine print.</small>
              </p>
              <p>The following snippet of text is <strong>rendered as bold text</strong>.</p>
              <p>The following snippet of text is <em>rendered as italicized text</em>.</p>
              <p>An abbreviation of the word attribute is <abbr title='attribute'>attr</abbr>.</p>
            </Grid.Column>

            <Grid.Column>
              <Grid
                centered
                columns={3}
                padded
                stackable
                style={{ margin: '-1.5em', width: 400 }}
                textAlign='center'
                >
                  <Grid.Column color='red' style={{ margin: '0.5em', height: 50 }}>Red</Grid.Column>
                  <Grid.Column color='orange' style={{ margin: '0.5em', height: 50 }}>Orange</Grid.Column>
                  <Grid.Column color='yellow' style={{ margin: '0.5em', height: 50 }}>Yellow</Grid.Column>
                  <Grid.Column color='olive' style={{ margin: '0.5em', height: 50 }}>Olive</Grid.Column>
                  <Grid.Column color='green' style={{ margin: '0.5em', height: 50 }}>Green</Grid.Column>
                  <Grid.Column color='teal' style={{ margin: '0.5em', height: 50 }}>Teal</Grid.Column>
                  <Grid.Column color='blue' style={{ margin: '0.5em', height: 50 }}>Blue</Grid.Column>
                  <Grid.Column color='violet' style={{ margin: '0.5em', height: 50 }}>Violet</Grid.Column>
                  <Grid.Column color='purple' style={{ margin: '0.5em', height: 50 }}>Purple</Grid.Column>
                  <Grid.Column color='pink' style={{ margin: '0.5em', height: 50 }}>Pink</Grid.Column>
                  <Grid.Column color='brown' style={{ margin: '0.5em', height: 50 }}>Brown</Grid.Column>
                  <Grid.Column color='grey' style={{ margin: '0.5em', height: 50 }}>Grey</Grid.Column>
                  <Grid.Column color='black' style={{ margin: '0.5em', height: 50 }}>Black</Grid.Column>
                </Grid>
              </Grid.Column>
            </Grid>

            <Header as='h2' dividing>Menu</Header>

            <Grid columns={3} doubling>
              <Grid.Column>
                <Menu
                  items={[
                    { key: '1', name: 'link-1', content: 'Link' },
                    { key: '2', name: 'link-2', content: 'Link' },
                    { key: '3', name: 'link-3', content: 'Link' },
                  ]}
                  pointing
                  secondary
                />
              </Grid.Column>

              <Grid.Column>
                <Menu
                  items={[
                    { key: '1', name: 'link-1', content: 'Link' },
                    { key: '2', name: 'link-2', content: 'Link' },
                    { key: '3', name: 'link-3', content: 'Link' },
                  ]}
                  pointing
                  tabular
                />
              </Grid.Column>

              <Grid.Column>
                <Menu
                  items={[
                    { key: 'l1', name: 'link-1', content: 'Link' },
                    { key: 'l2', name: 'link-2', content: 'Link' },
                    { key: 't1', name: 'text-1', content: 'Right text', position: 'right' },
                  ]}
                  pointing
                />
              </Grid.Column>
            </Grid>
      </Container>
    )
  }
}


export default ThemingLayout



// WEBPACK FOOTER //
// ./src/scenes/Themes.js